exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flow-navigation-container{text-align:center;margin:1em 0}.flow-navigation-container ul.navigation{margin:0}.flow-navigation-container ul.navigation li{font-size:12px;letter-spacing:.0625rem;font-weight:600;display:inline-block;margin:1px 2.5px}.flow-navigation-container ul.navigation li a{color:#373737;text-decoration:none;vertical-align:text-top;padding:5px 10px;text-transform:uppercase}.flow-navigation-container ul.navigation li.active{height:26px}.flow-navigation-container ul.navigation li.active a{border-radius:15px;background-color:#3c85df;color:#fff}.flow-navigation-container ul.navigation li.arrow{margin:0;color:#b6b6b6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/StepsNavigation/index.scss
// module id = 1024
// module chunks = 0